export const ACTION_TYPE = 'actionType';
export const WORKFLOW_ID = 'workflowId';